import React from "react";
import { useState } from "react";

const ReviewsDetailContent = ({contentData}) => {
    console.log(contentData, 'contentData')
    const comment = contentData.comment || "";
    const [value, setValue] = useState(false);

const toggleReadMore = () => {
  setValue(!value);
};

let previewText;

if (comment.length > 120 && !value) {
  previewText = comment.slice(0, 120) + '...';
} else {
  previewText = comment;
}


    return (
            <div key={contentData.id}
                 className="blog-detail-container" >

                {/* image section */}
                {/*<div className="image-container mb-2 rounded-2xl ">
                    <img
                        src={contentData.photo}
                        alt={contentData.title}
                        className="w-fit rounded-2xl "
                    />
                </div>*/}

                {/* content section */}
                <div className="content-section">
                    <p className="text-xl font-bold text-gray-500">{contentData.title}</p>
                    <p className="text-lg text-gray-600 dark:text-gray-400" dangerouslySetInnerHTML={{__html: contentData.comment}}>
                    </p>
                </div>
            </div>
    );
};

export default ReviewsDetailContent;
